import { Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

interface MatchListRowActionOverlayWrapperProps {
  forceEnabled?: boolean
  hoverable?: boolean
  placement: 'left' | 'right'
  width: string
}

export const MatchListRowActionOverlayWrapper = styled.div<MatchListRowActionOverlayWrapperProps>`
  ${({ placement }) => css`
    ${placement}: 1px;
    background: linear-gradient(
      to ${placement === 'left' ? 'right' : 'left'},
      rgba(245, 245, 245, 0.9) 70%,
      rgba(255, 255, 255, 0)
    );
    text-align: ${placement};
  `}

  ${({ width }) => css`
    width: ${width};
    max-width: ${width};
  `}

  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 28px;
  border-radius: 3px;
  position: absolute;
  z-index: 1;
  box-shadow: none;
  overflow: hidden;
  transition: max-width 200ms;

  &:not(.react-app-hoverable):not(.react-app-force-enabled) {
    max-width: 0;
  }

  svg {
    ${({ placement }) =>
      placement === 'right'
        ? `align-self: flex-end;
        margin-right: ${Spacing.S8}`
        : `align-self: flex-start;
        margin-left: ${Spacing.S8}`};
    cursor: pointer;
  }
`
